import { inherits as _inherits, classCallCheck as _classCallCheck, possibleConstructorReturn as _possibleConstructorReturn, getPrototypeOf as _getPrototypeOf, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, Reveal, getMarginBottomClass, IconStatusErrorOnlight, marginBottomLevels } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import styles from './field-feedback.css.js';

var FieldFeedback = /*#__PURE__*/function (_Component) {
  _inherits(FieldFeedback, _Component);

  function FieldFeedback() {
    _classCallCheck(this, FieldFeedback);

    return _possibleConstructorReturn(this, _getPrototypeOf(FieldFeedback).apply(this, arguments));
  }

  _createClass(FieldFeedback, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconAriaHidden = _this$props.iconAriaHidden,
          name = _this$props.name,
          textMap = _this$props.textMap,
          marginBottom = _this$props.marginBottom,
          marginTop = _this$props.marginTop,
          children = _this$props.children,
          rest = _objectWithoutProperties(_this$props, ["iconAriaHidden", "name", "textMap", "marginBottom", "marginTop", "children"]);

      return React.createElement(Reveal, {
        duration: 150,
        marginTop: marginTop
      }, children && React.createElement("div", _extends({
        className: cn(styles['FieldFeedback'], getMarginBottomClass(marginBottom)),
        id: "".concat(name, "-feedback")
      }, rest), React.createElement("div", {
        className: styles.container
      }, React.createElement("span", {
        className: styles.icon
      }, React.createElement(IconStatusErrorOnlight, {
        "aria-label": textMap.screenReaderPrefix,
        "aria-hidden": iconAriaHidden,
        "aria-describedby": "".concat(name, "-error-message"),
        marginBottom: 0
      })), React.createElement("span", {
        className: styles.message,
        id: "".concat(name, "-error-message")
      }, children))));
    }
  }]);

  return FieldFeedback;
}(Component);

_defineProperty(FieldFeedback, "defaultProps", {
  iconAriaHidden: 'false',
  textMap: {
    screenReaderPrefix: 'Error'
  },
  marginBottom: 0,
  marginTop: 2
});

FieldFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  iconAriaHidden: PropTypes.string,
  textMap: PropTypes.shape({
    screenReaderPrefix: PropTypes.string
  }),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  marginTop: PropTypes.oneOf(marginBottomLevels),

  /** docgen-from-context:<Field/> */
  name: PropTypes.string.isRequired,

  /** docgen-from-context:<Field/> */
  children: PropTypes.node
} : {};
var FieldFeedback$1 = withContext(Consumer, function (value) {
  return {
    name: value.name,
    children: value.invalid && value.error
  };
}, function (_ref) {
  var name = _ref.name;
  return {
    component: 'FieldFeedback',
    describerId: "".concat(name, "-error-message")
  };
})(FieldFeedback);
export default FieldFeedback$1;
export { FieldFeedback };